export const NombreProducto = {
  soat: 'ProductoSoat',
  viajes: 'ProductoViajesMov',
  movilidad: 'ProductoAutos',
  mascotas: 'ProductoMascotas',
  'pac-digital': 'ProductoPac',
  'arrendamiento-digital': 'ProductoArrendamientos',
  'proteccion-digital-personas': 'ProductoProteccionDigitalPersonas',
};
